import React, { useEffect, useMemo, useState } from "react";

const useInitialData = (languages) => {
  const language = JSON.parse(localStorage.getItem("languageSelector"));
  const memoLanguage = useMemo(() => languages, [JSON.stringify(languages)]);

  const [initialData, setInitialData] = useState(() => [
    {
      ItemContent: "فارسی",
      ItemValue: "fa-IR",
    },
  ]);

  useEffect(() => {
    const filterContent = memoLanguage?.filter(
      (fl) => fl.ItemValue === language
    );
    if (filterContent) {
      setInitialData(filterContent);
    }
  }, [memoLanguage]);

  return initialData;
};

export default useInitialData;
